module.exports = __webpack_public_path__ + "static/img/test-new-pic.6cdc3303.png";